var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBranches(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11396_138556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5131 17.4286H20.5399V14.5446C20.5399 14.4612 20.4716 14.3929 20.3881 14.3929H15.6827V12.5714H17.7318C17.8988 12.5714 18.0354 12.4348 18.0354 12.2679V6.80357C18.0354 6.63661 17.8988 6.5 17.7318 6.5H12.2676C12.1006 6.5 11.964 6.63661 11.964 6.80357V12.2679C11.964 12.4348 12.1006 12.5714 12.2676 12.5714H14.3167V14.3929H9.61131C9.52783 14.3929 9.45953 14.4612 9.45953 14.5446V17.4286H7.48631C7.31935 17.4286 7.18274 17.5652 7.18274 17.7321V23.1964C7.18274 23.3634 7.31935 23.5 7.48631 23.5H12.9506C13.1176 23.5 13.2542 23.3634 13.2542 23.1964V17.7321C13.2542 17.5652 13.1176 17.4286 12.9506 17.4286H10.8256V15.7589H19.1738V17.4286H17.0488C16.8818 17.4286 16.7452 17.5652 16.7452 17.7321V23.1964C16.7452 23.3634 16.8818 23.5 17.0488 23.5H22.5131C22.6801 23.5 22.8167 23.3634 22.8167 23.1964V17.7321C22.8167 17.5652 22.6801 17.4286 22.5131 17.4286ZM11.8122 18.8705V22.058H8.6247V18.8705H11.8122ZM13.406 11.1295V7.94196H16.5935V11.1295H13.406ZM21.3747 22.058H18.1872V18.8705H21.3747V22.058Z",
    fill: "#414141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11396_138556"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranches);
export default __webpack_public_path__ + "static/media/branches.e5198e21c31d26390e2984f7e71170f3.svg";
export { ForwardRef as ReactComponent };